import { useTranslation } from "react-i18next";
import { CheckIcon, TrashIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { User } from "../../models/User";
import { ConfirmationModal } from "../ConfirmationModal";

interface Props {
    info: {
        show: boolean;
        user?: User;
    };
    onClose: () => void;
    deleteUser: (user: User) => void
}

export const DeleteAgentModal: React.FC<Props> = ({
    info,
    onClose,
    deleteUser
}) => {

    const { t } = useTranslation();

    const onDeleteUser = () => {
        deleteUser(info.user!)
        onClose();
    };

    return(
        <ConfirmationModal 
            label={t("DELETE_USER")}
            isDeleteConfirm={true}
            isOpen={info.show}
            onClose={onClose}
            cancelButton={{ label: t("CLOSE"), icon: <XMarkIcon />, onClick: onClose, }}
            saveButton={{ label: t("DELETE"), icon: <TrashIcon />, onClick: onDeleteUser }}
        >
            <div className='w-full flex flex-wrap items-center justify-center'>
                <label className="text-lg font-semibold py-4 px-2 text-center">
                    {t('DELETE_USER_MESSAGE', {label: `${info.user?.first_name} ${info.user?.last_name}`})}
                </label>
            </div>
        </ConfirmationModal>
    )
}